export const OPEN_PARTNER_ORDER = 'PartnerOrder::OpenPartnerOrder';
export const SET_ORDER_STEP = 'PartnerOrder::SetOrderStep';
export const SET_PRODUCT_NAME = 'PartnerOrder::SetProductName';
export const SET_PRODUCT_PRICE = 'PartnerOrder::SetProductPrice';
export const SET_PRODUCT_ID = 'PartnerOrder::SetProductId';
export const SET_DELIVERY_ACTIVE_OPTION = 'PartnerOrder::SetDeliveryActiveOption';
export const SET_DELIVERY_ERRORS = 'PartnerOrder::SetDeliveryErrors';
export const SET_COURIER_DATA = 'PartnerOrder::SetCourierData';
export const SET_COURIER_ADDRESS = 'PartnerOrder::SetCourierAddress';
export const SET_COURIER_DATE = 'PartnerOrder::SetCourierDate';
export const SET_COURIER_ACTIVE_DATE = 'PartnerOrder::SetCourierActiveDate';
export const SET_PICKUP_DATA = 'PartnerOrder::SetPickupData';
export const SET_ACTIVE_POINT = 'PartnerOrder::SetActivePoint';
export const SET_ACTIVE_PAYMENT_SLUG = 'PartnerOrder::SetActivePaymentSlug';
export const SET_POINTS_COLLAPSED = 'PartnerOrder::SetPointsCollapsed';
export const SET_POINTS_VIEW_STATE = 'PartnerOrder::SetPointsViewState';
export const SET_PICKUP_SORT_BY = 'PartnerOrder::SetPickupSortBy';
export const SET_PICKUP_REVERSE_STATE = 'PartnerOrder::SetPickupReverseState';
export const SET_SEARCH_QUERY = 'PartnerOrder::SetSearchQuery';
export const SET_SUCCESS_MESSAGE = 'PartnerOrder::SetSuccessMessage';
export const SET_AGREEMENT_CONTENT = 'PartnerOrder::SetAgreementContent';
export const SET_COURIER_TIPS_ADDRESS = 'PartnerOrder::SetCourierTipsAddress';
